export const manifest = {
  screens: {
    scr_1uy4it: { name: "Home", route: "/" },
  },
}
